import React from 'react';
import { ThemeProvider } from 'styled-components';
import AppProvider from '../AppContext';
import Layout from 'components/Layout';
import GlobalStyles from 'styles/GlobalStyles';
import theme from 'assets/Theme';

function App() {
  const handleUpdate = (e) => {
    const suffix = e.target.dataset.sizing || '';
    console.log(document.documentElement.style);
    document.documentElement.style.setProperty(
      `--${e.target.name}`,
      e.target.value + suffix
    );
  };

  return (
    <AppProvider>
      <ThemeProvider theme={theme}>
        <GlobalStyles />
        <Layout>
          <h2>
            Update CSS Variables with <span className="hl">JS</span>
          </h2>
          <div className="controls">
            <label htmlFor="spacing">Spacing:</label>
            <input
              id="spacing"
              type="range"
              name="spacing"
              min="10"
              max="200"
              value="10"
              data-sizing="px"
              onChange={handleUpdate}
            />
            <label htmlFor="blur">Blur:</label>
            <input
              id="blur"
              type="range"
              name="blur"
              min="0"
              max="25"
              value="10"
              data-sizing="px"
              onChange={handleUpdate}
            />
            <label htmlFor="base">Base Color</label>
            <input
              id="base"
              type="color"
              name="base"
              value="#ffc600"
              onChange={handleUpdate}
            />
          </div>

          <img
            alt="background"
            src="https://source.unsplash.com/7bwQXzbF6KE/800x500"
          />
        </Layout>
      </ThemeProvider>
    </AppProvider>
  );
}

export default App;
